<template>
  <v-container fluid style="padding-left: 300px">
    <v-row>
      <v-col cols="12">
        <v-form class="mb-4" @submit.prevent="searchInspections">
          <v-card elevation="0" tile outlined>
            <v-card-text>
              <div class="mt-3">検索条件を入力してください</div>
              <v-layout row class="ma-0">
                <v-switch
                  v-model="isCurrentOnly"
                  persistent-hint
                  class="p-settingForm--inputSwitch"
                  hint="※新しいCC結果だけ表示する"
                />
              </v-layout>
              <v-layout row>
                <v-text-field
                  v-model="searchQuery.order_id_eq"
                  label="発注ID"
                  style="max-width: 150px"
                  type="number"
                  clearable
                  class="ma-2"
                />
                <v-text-field
                  v-model="searchQuery.order_post_title_cont"
                  label="記事タイトル"
                  style="max-width: 400px"
                  clearable
                  class="ma-2"
                />
                <v-text-field
                  v-model="searchQuery.order_user_name_cont"
                  label="ライター名"
                  style="max-width: 150px"
                  clearable
                  class="ma-2"
                />
                <v-select
                  v-model="searchQuery.status_eq"
                  :items="selectableStatuses"
                  item-text="type"
                  style="max-width: 150px"
                  class="ma-2"
                  item-value="value"
                  clearable
                  label="CCステータス"
                />
                <v-btn
                  color="primary"
                  dark
                  tile
                  outlined
                  class="ma-2"
                  type="submit"
                  @click="searchInspections"
                  @submit.prevent="searchInspections"
                >
                  検索
                </v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>

      <v-col cols="12">
        <h2 class="title mb-3">コピーチェック一覧</h2>
        <CopyCheckIndexTable
          :inspections="inspections"
          @getCcdResult="getCcdResult"
          @remandOrder="remandOrder"
          @passDetection="passDetection"
        />
        <infinite-loading
          spinner="spiral"
          class="mt-2"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <template v-slot:no-more>
            <v-chip label outlined> 全て表示されました。 </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip label outlined> 表示できるものがありません。 </v-chip>
          </template>
        </infinite-loading>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CopyCheckIndexTable from '@/components/commons/CopyCheckIndexTable'
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import Qs from 'qs'
import { deserialize } from 'deserialize-json-api'
import headUtilsMixin from '@/mixins/head_utils'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    CopyCheckIndexTable,
    InfiniteLoading
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      page: 1,
      pageTitle: 'コピーチェック一覧',
      siteKey: null,
      isCurrentOnly: true,
      searchQuery: {
        status_eq: null,
        order_id_eq: '',
        order_post_title_cont: '',
        order_user_name_cont: ''
      },
      selectableStatuses: [
        { type: '結果未取得', value: 2 },
        { type: '結果取得済', value: 3 },
        { type: '検収待ち', value: 0 },
        { type: '検収中', value: 1 },
        { type: '完了', value: 90 }
      ],
      inspections: [],
      infiniteId: +new Date()
    }
  },
  computed: {
    ...mapState({
      currentUserAuth: (state) => state.UserAuthStore.currentUserAuth
    }),
    ...mapGetters('UserAuthStore', ['selectableSites'])
  },
  created () {
    this.$watch(
      () => this.$route.params,
      (params) => {
        this.siteKey = params.siteKey
        this.searchInspections()
      }
    )
  },
  mounted () {
    this.siteKey = this.$route.params.siteKey
  },
  methods: {
    getCcdResult (inspectionId) {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .patch(`/api/master/inspections/${inspectionId}/copy_check/result`, {
          site_key: this.siteKey
        })
        .then(
          ({ data }) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const inspection = deserialize(data).data
            let payload = {}
            if (inspection.ccdEndAt) {
              payload = {
                status: 200,
                message: 'コピーチェックの結果を取得しました'
              }
              this.replaceInspections(inspection)
            } else {
              payload = {
                status: 202,
                message: 'コピーチェック中です。しばらくお待ちください。'
              }
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    remandOrder (inspectionId) {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .patch(`/api/master/inspections/${inspectionId}/copy_check/remand`, {
          site_key: this.siteKey
        })
        .then(
          ({ data }) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const inspection = deserialize(data).data
            const payload = {
              status: 200,
              message: '記事を差し戻しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.replaceInspections(inspection)
          },
          (error) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    passDetection (inspectionId) {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .patch(`/api/master/inspections/${inspectionId}/copy_check/pass`, {
          site_key: this.siteKey
        })
        .then(
          ({ data }) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const inspection = deserialize(data).data
            const payload = {
              status: 200,
              message: 'コピーチェックを通過しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.replaceInspections(inspection)
          },
          (error) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    replaceInspections (inspection) {
      let changeIndex = null
      this.inspections.forEach((el, index) => {
        if (el.id == inspection.id) {
          changeIndex = index
        }
      })
      if (changeIndex !== null) {
        this.inspections.splice(changeIndex, 1, inspection)
      }
    },
    searchInspections () {
      this.page = 1
      this.inspections = []
      this.infiniteId++
    },
    infiniteHandler ($state) {
      if (!this.siteKey) {
        $state.complete()
        return true
      }
      axios
        .get('/api/master/order/copy_checks', {
          params: {
            page: this.page,
            site_key: this.siteKey,
            is_current_only: this.isCurrentOnly,
            q: this.searchQuery
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          const fetchedInspections = deserialize(data).data
          if (fetchedInspections.length > 0) {
            this.page++
            this.inspections = this.inspections.concat(fetchedInspections)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    },
    selectedSiteKey () {
      return this.currentUserAuth.sites.find(
        (site) => site.site_key == this.siteKey
      )
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
